export default __webpack_public_path__ + "static/realWorldImage2-7f8239980e8099fa567b0fc659485b0d.webp";